import styled from "@emotion/styled"
import { Button, Typography } from "@mui/material"
import { useState } from "react"
import { CopyIcon, Desktop, useIsDesktop } from "ui"

const StyledCopyButton = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: fit-content;
  ${(p) => p.theme.breakpoints.down("md")} {
    padding: 0px !important;
    justify-content: flex-end;
  }
`

const CopyButton = ({ link }: { link: string }) => {
  const isDesktop = useIsDesktop()

  const [copySuccess, setCopySuccess] = useState(false)

  const handleCopyOrShare = async () => {
    if (isDesktop && navigator?.clipboard) {
      try {
        await navigator.clipboard.writeText(link)
        setCopySuccess(true)
        setTimeout(() => {
          setCopySuccess(false)
        }, 3000)
      } catch (err) {
        console.error("Copy failed", err)
      }
      return
    }
    if (!isDesktop && navigator?.share) {
      navigator?.share({ text: "שיתוף משרה", url: link })
    }
  }
  return (
    <StyledCopyButton onClick={handleCopyOrShare}>
      <CopyIcon />
      <Desktop arialive="polite">
        <Typography variant="body3">
          {copySuccess ? "הקישור הועתק בהצלחה" : "שיתוף משרה"}
        </Typography>{" "}
      </Desktop>
    </StyledCopyButton>
  )
}
export default CopyButton
